/**
 * ABC-SE help-center config (labels + routes).
 */
export const HELP_LABELS = {
  sidebarTitle: 'Populära ämnen',
  popular:      'Vanligaste',
  // Reklamation hidden — uncomment label + route (and restore the App.js route) to bring it back.
  // claims:       'Reklamation',
  contact:      'Kontakta oss',
  sizeGuide:    'Storleksguide',
};

export const HELP_ROUTES = {
  faq:       '/clothing/abc-se/faq',
  // claims:    '/clothing/abc-se/claims',
  contact:   '/clothing/abc-se/contact',
  sizeGuide: '/clothing/abc-se/size-guide',
};
